import { SelectV2, SelectV2Option } from '@cimplico/components';
import { useEffect, useMemo, useState } from 'react';
import { useXeroReportTaxTypes } from '../../../../../queries/use-xero-report-tax-types';
import { XeroReportTaxTypeEnum } from '../../../../../types/entity';

type XeroReportTaxTypeSelectProps = {
    value?: XeroReportTaxTypeEnum | null;
    errorMessage?: string;
    disabledHint?: string;
    isDisabled?: boolean;
    onChange: (type: XeroReportTaxTypeEnum | null) => void;
};

function XeroReportTaxTypeSelect({ value, errorMessage, disabledHint, isDisabled, onChange }: XeroReportTaxTypeSelectProps): JSX.Element {
    const [selected, setSelected] = useState<SelectV2Option[]>([]);
    const [search, setSearch] = useState('');

    const xeroReportTaxTypesQuery = useXeroReportTaxTypes();

    const allOptions: SelectV2Option[] = useMemo(() => {
        const allOptions: SelectV2Option[] = (xeroReportTaxTypesQuery.data?.xeroReportTaxTypes || [])
            .filter((opt) => opt.canCreate)
            .filter((type) => type.type.toString().toLowerCase().includes(search.toLowerCase()))
            .map((option) => {
                return {
                    value: option.type,
                    label: option.name || option.type,
                    description: `(${option.countryCode.toString()})`,
                };
            });
        return allOptions;
    }, [xeroReportTaxTypesQuery.data?.xeroReportTaxTypes, search]);

    function handleEntityTypeChange(options: SelectV2Option[]): void {
        onChange(options.length === 0 ? null : (options[0].value as XeroReportTaxTypeEnum));
    }

    useEffect(() => {
        let displayName: string | undefined;
        if (value && xeroReportTaxTypesQuery.data?.xeroReportTaxTypes) {
            displayName = xeroReportTaxTypesQuery.data?.xeroReportTaxTypes.find((t) => t.type === value)?.name;
        }
        setSelected(value ? [{ label: displayName || value, value }] : []);
    }, [value, xeroReportTaxTypesQuery.data?.xeroReportTaxTypes]);

    return (
        <div>
            <SelectV2
                size="small"
                placeholder="Select xero report tax type..."
                keepSelectedOptions
                onSearch={setSearch}
                errorMessage={errorMessage}
                value={selected}
                disabled={isDisabled}
                disabledHint={disabledHint}
                onChange={handleEntityTypeChange}
                allowOverflow
                options={allOptions}
            />
        </div>
    );
}
export default XeroReportTaxTypeSelect;
